export interface Author {
  id: string;
  name: string;
  bio: string;
  role: string;
}

export const AUTHORS: Record<string, Author> = {
  editorial: {
    id: "editorial",
    name: "PieFolio Editorial",
    role: "Investing research team",
    bio: "The PieFolio Editorial team researches brokers, portfolio strategy, and AI-assisted investing for everyday investors. We don't give financial advice — we give clarity.",
  },
};
